var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"buyer-video-details"},[_vm._t("default"),_vm._v(" "),(_vm.videoJob)?_c('div',{staticClass:"buyer-video-details__data-cont"},[_c('video-service')],1):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }